import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FeatureList } from "../utils";
import { Panel } from "../utils";
import { cx } from "module/main/util";
import { formatNumber } from "module/main/util";
import { Button } from "module/common/components/Buttons";
export var dncPlanDescriptions = [
    {
        id: "api_dnc_scrub",
        label: "DNC Scrub",
        price: "$100",
        suffix: "/mo",
        description: "1,000 numbers / minute",
        features: [
            "National DNC registry check",
            "Integrated in Skip Sherpa",
            "Standard throughput",
            "Cancel anytime",
        ],
        cta: "Get started",
    },
    {
        id: "api_dnc_scrub_plus",
        label: "DNC Scrub Plus",
        price: "$750",
        suffix: "/mo",
        badge: "Save $250+/mo vs. competitors",
        selected: true,
        description: "No rate limit",
        features: [
            "National DNC registry check",
            "Integrated in Skip Sherpa",
            "Unlimited throughput",
            "Cancel anytime",
        ],
        cta: "Get started",
    },
];
export var subscriptionPlanDescriptions = [
    {
        id: "api_payg",
        label: "Pay As You Go",
        price: "$30",
        suffix: "/mo",
        description: "200 hits / month · $0.15 per hit",
        features: [
            "Rolls over up to 1,000 hits",
            "Owner contact data",
            "Enhanced property data",
            "LLC & trust contacts",
            "Cancel anytime",
        ],
        cta: "Get started",
    },
    {
        id: "api_payg_plus",
        label: "Pay As You Go Plus",
        price: "$100",
        suffix: "/mo",
        badge: "Most popular",
        selected: true,
        description: "1,000 hits / month · $0.10 per hit",
        features: [
            "Rolls over up to 5,000 hits",
            "Everything in Pay as you go",
            "5× the hit volume",
            "33% lower cost per hit",
            "Cancel anytime",
        ],
        cta: "Get started",
    },
    {
        id: "api_custom_contract",
        label: "Custom Contract",
        price: "Let's talk",
        description: "Custom plans · Volume pricing · Dedicated manager · SLA & uptime guarantees",
        features: [],
        cta: "Get started",
    },
];
var PlandAndAddonCard = function (_a) {
    var dbPlan = _a.dbPlan, onClick = _a.onClick, _b = _a.current, current = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.compact, compact = _d === void 0 ? false : _d;
    var descriptions = dbPlan.id.includes("dnc")
        ? dncPlanDescriptions
        : subscriptionPlanDescriptions;
    var plan = descriptions.find(function (_a) {
        var id = _a.id;
        return id === dbPlan.id;
    });
    if (!plan)
        return null;
    return (_jsxs(Panel, { className: cx("relative flex h-full flex-col", plan.selected || current ? "border-2 border-primary" : "border-sherpaCream", compact ? "p-4" : "p-6"), children: [plan.badge ? (_jsx("div", { className: "whitespace-nowrap absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-badgeOrange px-8 py-1 text-[11px] font-bold text-white", children: plan.badge })) : null, _jsxs("div", { className: "mb-3", children: [_jsx("div", { className: "text-xs font-extrabold uppercase tracking-wide text-slate", children: plan.label }), _jsxs("div", { className: "mt-2 flex items-end gap-1 text-ink", children: [_jsx("span", { className: cx("font-extrabold", compact ? "text-2xl" : "text-4xl", "text-primary"), children: dbPlan.id.includes("custom_contract") || typeof dbPlan.price !== "number"
                                    ? plan.price
                                    : "$".concat(formatNumber({ value: dbPlan.price })) }), plan.suffix ? _jsx("span", { className: "mb-1 text-sm text-slate", children: plan.suffix }) : null] }), plan.description ? _jsx("p", { className: "mt-2 text-sm text-slate", children: plan.description }) : null] }), _jsx(FeatureList, { items: plan.features, className: "flex-1" }), plan.cta ? (_jsx(Button, { className: "mt-5 w-full", variant: current ? "primary" : plan.selected ? "primary" : "outline", onClick: onClick, disabled: disabled || current, children: current ? "Current" : plan.cta })) : null] }));
};
export default PlandAndAddonCard;
